import React from 'react'
import {FaCheckCircle} from 'react-icons/fa'
import {
  isUserActive,
  isUserOnTrial,
  isUserCancelled,
  isUserInactive,
  isUserFailed,
} from '../../helper/userHelpers'

const SubscriptionPlan = ({
  title,
  features=[],
  currentUser,
  // subscriptionStarted, // Tracks if user clicked subscribe and Stripe flow is in progress
  // isLoading,
  isCancelling,
  // handleStartSubscription,
  // handleResubscribe,
  openCancelModal,
  activePatientCount,
  deviceCount,
  // showSubscribeButton = true, // New prop to control subscribe button visibility
}) => {
  // Derive states from currentUser using helper functions
  const isActive = isUserActive(currentUser)
  const isTrial = isUserOnTrial(currentUser)
  const isInactive = isUserInactive(currentUser)
  const isSoftCanceled = isUserCancelled(currentUser)
  const isNeverSubscribed = !currentUser?.subscription_status
  const isExpired = isUserInactive(currentUser) || isUserFailed(currentUser)

  // Don't show subscribe button for trial/inactive users since they see BillingDetails
  // const shouldShowSubscribeButton = showSubscribeButton && !(isTrial || isInactive)

  return (
    <>
      {/* Main Subscription Card */}
      <div
        className='d-flex bg-white shadow border rounded-5 text-white p-5 w-100'
        style={{maxWidth: '500px'}}
      >
        <div className='text-black rounded  mb-4'>
          <h1 className='text-black fw-bold mb-3' style={{fontSize: '3.5rem'}}>
            {title}
          </h1>
          <ul className="list-unstyled fs-5">
            {features.map((feature, idx) => (
              <li key={idx} className="mb-3 d-flex align-items-center">
                <FaCheckCircle className="text-success me-2 fs-5" />
                {feature}
              </li>
            ))}
          </ul>
        </div>

        {/* Moving to Stripe Portal */}
        {/* Cancel button
            {isActive && (
              <PrimaryButton
                className='w-100 mt-4'
                color='danger'
                disabled={isCancelling}
                onClick={openCancelModal}
              >
                {isCancelling ? 'Cancelling...' : 'Cancel Subscription'}
              </PrimaryButton>
            )}

            {isSoftCanceled && !subscriptionStarted && (
                <PrimaryButton
                  className='w-100 mt-2'
                  color='primary'
                  disabled={isLoading || activePatientCount === 0}
                  onClick={handleResubscribe}
                >
                  {isLoading ? 'Processing...' : 'Subscribe'}
                </PrimaryButton>
            )}

            {/* Subscribe button - for trial users and new/expired users */}
        {/* {(isTrial || isNeverSubscribed || isExpired) && !subscriptionStarted && (
                <PrimaryButton
                  className='w-100 mt-4'
                  color='primary'
                  disabled={isLoading || activePatientCount === 0}
                  onClick={handleStartSubscription}
                >
                  {isLoading ? 'Processing...' : 'Subscribe'}
                </PrimaryButton>
            )} */}
      </div>
    </>
  )
}

export default SubscriptionPlan
